import Spinner = require('spin.js');

/**
 * Exporting the Spinner prototype from spin.js library
 */
export const SpinJSSpinner = Spinner;



// WEBPACK FOOTER //
// ./src/Constants/SpinJSSpinner.ts